import ListKeyword from './components/ListKeyword';
import styles from './style.module.css';

function Keywords() {
  return (
    <div className={styles.container}>
      <ListKeyword />
    </div>
  );
}

export default Keywords;
